var React = require('react');

function Jp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M177.2 0h708.6v708.7H177.2z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(-128) scale(.72249)","key":1},[React.createElement("path",{"fill":"#fff","d":"M0 0h1063v708.7H0z","key":0}),React.createElement("circle",{"cx":"523.1","cy":"344.1","r":"194.9","fill":"#d30000","transform":"translate(-59.7 -34.5) scale(1.1302)","key":1})])]);
}

Jp.defaultProps = {"id":"flag-icon-css-jp","viewBox":"0 0 512 512"};

module.exports = Jp;

Jp.default = Jp;
